module.exports = __webpack_public_path__ + "static/media/EDIT2-FVCON-marca-registrada-azul-negro.82bf536a.png";